import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { PortalShell } from "@/components/layout/PortalShell";
import { STAFF_NAV } from "@/lib/staff-nav";
import { OperationsBanner } from "@/components/staff/OperationsBanner";
import { MessageInbox } from "@/components/messaging/MessageInbox";

export const Route = createFileRoute("/staff/messages")({
  head: () => ({
    meta: [
      { title: "Support Inbox — Operations" },
      { name: "description", content: "Read and respond to client support messages." },
      { property: "og:title", content: "Support Inbox — Operations" },
      { property: "og:description", content: "Read and respond to client support messages." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: () => (
    <ProtectedRoute requiredRole="staff">
      <PortalShell title="Support Inbox" nav={STAFF_NAV}>
        <OperationsBanner />
        <MessageInbox scope="staff" />
      </PortalShell>
    </ProtectedRoute>
  ),
});
